/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReceiptValidationRequestDto } from '../../models/receipt-validation-request-dto';

export interface InAppPurchaseControllerVerifyPurchaseByOriginalAppUserId$Params {
      body: ReceiptValidationRequestDto
}

export function inAppPurchaseControllerVerifyPurchaseByOriginalAppUserId(http: HttpClient, rootUrl: string, params: InAppPurchaseControllerVerifyPurchaseByOriginalAppUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<{
}>> {
  const rb = new RequestBuilder(rootUrl, inAppPurchaseControllerVerifyPurchaseByOriginalAppUserId.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      }>;
    })
  );
}

inAppPurchaseControllerVerifyPurchaseByOriginalAppUserId.PATH = '/api/in-app-purchase/verify-purchase';
